import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Search } from '@saucelabs/ds-inputs';
import { debounce } from 'lodash';

import actions from '../../actions';
import selectors from '../../selectors';
import { trackEvent, MANUAL_EVENTS } from '../../../../tracking';

const TRACK_SEARCH_DEBOUNCE_THRESHOLD_MS = 800;

const SearchFilter: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    searchTerm: currentSearchTerm,
    testType,
  } = useSelector(selectors.mobileSelectionSelector);

  const trackSearchDebounced = useMemo(() => (
    debounce((searchTerm: string) => {
      if (searchTerm) {
        trackEvent(MANUAL_EVENTS.SEARCH_REAL_DEVICE, {
          input: searchTerm,
          testType,
        });
      }
    }, TRACK_SEARCH_DEBOUNCE_THRESHOLD_MS)
  ), [testType]);

  return (
    <div className="w-39.75 mr-2 mb-0.5 self-end">
      <Search
        data-qa="device-filter-bar-search"
        defaultValue={currentSearchTerm}
        onChange={(newSearchTerm) => {
          void dispatch(actions.updateMobileSelectionSearchTerm(newSearchTerm));
          trackSearchDebounced(newSearchTerm);
        }}
        placeholder="Search by name"
      />
    </div>
  );
};

export default SearchFilter;
